import { useMutation, useQueryClient } from '@tanstack/react-query';
import { regionApi } from '../api/region.api';
import { regionKeys } from '../api/region.keys';
import toast from 'react-hot-toast';
import type { AxiosError } from 'axios';
import type { ApiErrorResponse, RegionFormData } from '@/shared/types';

export function useCreateRegion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: RegionFormData) => regionApi.create(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: regionKeys.all });
      toast.success('Region created');
    },
    onError: (err: AxiosError<ApiErrorResponse>) => {
      toast.error(err.response?.data?.message || 'Failed to create');
    },
  });
}

export function useUpdateRegion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string | number; data: RegionFormData }) =>
      regionApi.update(id, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: regionKeys.all });
      toast.success('Region updated');
    },
    onError: (err: AxiosError<ApiErrorResponse>) => {
      toast.error(err.response?.data?.message || 'Failed to update');
    },
  });
}

export function useDeleteRegion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string | number) => regionApi.delete(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: regionKeys.all });
      toast.success('Region deleted');
    },
    onError: (err: AxiosError<ApiErrorResponse>) => {
      toast.error(err.response?.data?.message || 'Failed to delete');
    },
  });
}
